"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ExternalPaymentEventRejections = void 0;
var ExternalPaymentEventRejections;
(function (ExternalPaymentEventRejections) {
    ExternalPaymentEventRejections["RESPONSE_IS_NOT_SUCCESSFUL"] = "RESPONSE_IS_NOT_SUCCESSFUL";
    ExternalPaymentEventRejections["BAD_REQUEST"] = "BAD_REQUEST";
    ExternalPaymentEventRejections["WRONG_SIGNATURE"] = "WRONG_SIGNATURE";
    ExternalPaymentEventRejections["WRONG_TERMINAL_KEY"] = "WRONG_TERMINAL_KEY";
    ExternalPaymentEventRejections["WRONG_CUSTOMER"] = "WRONG_CUSTOMER";
    ExternalPaymentEventRejections["WRONG_PAYMENT_METHOD"] = "WRONG_PAYMENT_METHOD";
    ExternalPaymentEventRejections["ORDER_NOT_FOUND"] = "ORDER_NOT_FOUND";
    ExternalPaymentEventRejections["ORDER_ALREADY_CONFIRMED"] = "ORDER_ALREADY_CONFIRMED";
    ExternalPaymentEventRejections["ORDER_HAS_NO_NECESSARY_DATA"] = "ORDER_HAS_NO_NECESSARY_DATA";
    ExternalPaymentEventRejections["REQUEST_HAS_NO_AMOUNT"] = "REQUEST_HAS_NO_AMOUNT";
    ExternalPaymentEventRejections["USER_DOES_NOT_EXIST"] = "USER_DOES_NOT_EXIST";
    ExternalPaymentEventRejections["USER_HAS_NO_SUBSCRIPTION"] = "USER_HAS_NO_SUBSCRIPTION";
    ExternalPaymentEventRejections["PLAN_IS_ARCHIVED"] = "PLAN_IS_ARCHIVED";
    ExternalPaymentEventRejections["UNKNOWN"] = "UNKNOWN";
    ExternalPaymentEventRejections["SIGNATURE_NOT_FOUND"] = "SIGNATURE_NOT_FOUND";
    ExternalPaymentEventRejections["INCORRECT_STATUS"] = "INCORRECT_STATUS";
    ExternalPaymentEventRejections["ADDON_NOT_FOUND"] = "ADDON_NOT_FOUND";
    ExternalPaymentEventRejections["INCORRECT_EVENT_TYPE"] = "INCORRECT_EVENT_TYPE";
})(ExternalPaymentEventRejections || (exports.ExternalPaymentEventRejections = ExternalPaymentEventRejections = {}));
//# sourceMappingURL=external-payment-event-rejections.enum.js.map